const localGlobal = window as any;
const _releaseVersion: string = localGlobal._releaseVersion == null ? "" : localGlobal._releaseVersion; // Will be replaced by Octopus on deployment.
const _releaseEnvironment: string = localGlobal._releaseEnvironment == null ? "" : localGlobal._releaseEnvironment; // Will be replaced by Octopus on deployment.
const _releaseTimestamp: string = localGlobal._releaseTimestamp == null ? "" : localGlobal._releaseTimestamp; // Will be replaced by Octopus on deployment.
const _buildVersion: string = localGlobal._buildVersion == null ? "" : localGlobal._buildVersion; // Will be replaced by TeamCity on build.
const _assetServerUrl: string = localGlobal._assetServerUrl == null ? "" : localGlobal._assetServerUrl; // Will be replaced by Octopus on deployment.
const identityUrl = "https://identity.test.axxess.tech";
const _messagingServerUrl: string =
    localGlobal._messagingServerUrl?.startsWith("#") || localGlobal._messagingServerUrl == null
        ? "https://messaging-api.test.axxess.tech"
        : localGlobal._messagingServerUrl; // Will be replaced by Octopus on deployment.
// created a variable to hold axxess central link
const _axxessCentral: string =
    localGlobal._axxessCentral?.startsWith("#") || localGlobal._axxessCentral == null
        ? "https://central.test.axxess.tech"
        : localGlobal._axxessCentral; // Will be replaced by Octopus on deployment.
const _authorityUrl: string =
    localGlobal._authorityUrl?.startsWith("#") || localGlobal._authorityUrl == null
        ? identityUrl
        : localGlobal._authorityUrl; // Will be replaced by Octopus on deployment.
const _hospiceReceptionistUrl: string =
    localGlobal._hospiceReceptionistUrl?.startsWith("#") || localGlobal._hospiceReceptionistUrl == null
        ? "https://hospice-receptionist.test.axxess.tech"
        : localGlobal._hospiceReceptionistUrl;

export enum ReleaseEnvironments {
    Production = "Production" as any,
    Staging = "Staging" as any,
    Development = "Development" as any,
    Local = "Local" as any,
    Testing = "Testing" as any
}

export default class Infrastructure {
    public static get releaseVersion(): string {
        return _releaseVersion.startsWith("#") ? "0.0.0.1" : _releaseVersion;
    }
    public static get releaseEnvironment(): string {
        return _releaseEnvironment.startsWith("#") ? "Local" : _releaseEnvironment;
    }
    public static get isProdEnvironment(): boolean {
        return _releaseEnvironment === ReleaseEnvironments.Production.toString();
    }
    public static get buildVersion(): string {
        return _buildVersion.startsWith("#") ? "0.0.0.2" : _buildVersion;
    }
    public static get releaseTimestamp(): string {
        return _releaseTimestamp;
    }
    public static get assetServerUrl(): string {
        return _assetServerUrl;
    }
    public static get messagingServerUrl(): string {
        return _messagingServerUrl;
    }

    public static get axxessCentral(): string {
        return _axxessCentral;
    }

    public static get authorityUrl(): string {
        return _releaseEnvironment === ReleaseEnvironments.Local.toString() ? identityUrl : _authorityUrl;
    }

    public static get hospiceReceptionistUrl(): string {
        return _hospiceReceptionistUrl;
    }
}
